let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4Uo8")).then(() => parcelRequire('6BVw6'));